import http from '../../../api/axios';
import { apiUrl } from '../../../api/apiUrl';
import { Values } from '../../../forms/NumericalSeriesCounters/NumericalSeriesCountersForm.types';
import { handleApiErrors } from '../../../api/apiErrorHandler';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { NumericalSeriesCounterForm } from '../../../forms/NumericalSeriesCounters/NumericalSeriesCountersForm';
import { useTranslation } from '../../../context/translationContext';
import { paths } from '../../RouterContainer';
import { useBreadcrumbs } from '../../../hooks/useBreadcrumbs';
import { useEffect } from 'react';
import { useLoading } from '../../../context/loadingContext';

/**
 * Page component for editing existing numerical serie of company
 */
export const NumericalSeriesCounterUpdatePage = () => {
  const { companyId, numericalSeriesId, id } = useParams();
  const { t } = useTranslation();
  const { state: counter } = useLocation();
  const navigate = useNavigate();
  const { startLoading, stopLoading } = useLoading();
  const { setBreadcrumbs } = useBreadcrumbs();
  const isCurrent = window.location.pathname.includes(`current`);
  useEffect(() => {
    setBreadcrumbs([
      {
        path: `${paths.MY_COMPANIES}`,
        name: 'navigation.my-companies',
      },
      {
        path: `${paths.MY_COMPANIES}/edit/${isCurrent ? `current` : companyId}`,
        name: 'navigation.company-setting',
      },
      {
        path: `${paths.MY_COMPANIES}/${isCurrent ? `current` : companyId}/${
          paths.NUMERICAL_SERIES
        }/edit/${numericalSeriesId}`,
        name: 'navigation.numerical-series-edit',
      },
      {
        path: `${paths.MY_COMPANIES}/${isCurrent ? `current` : companyId}/${
          paths.NUMERICAL_SERIES
        }/${numericalSeriesId}/${paths.NUMERICAL_SERIES_COUNTERS}/edit/${id}`,
        name: 'navigation.numerical-series-counter-edit',
      },
    ]);
  }, []);

  /**
   * Back button action
   */
  const handleOnBack = () =>
    navigate(
      `/${paths.MY_COMPANIES}/${isCurrent ? `current` : companyId}/${
        paths.NUMERICAL_SERIES
      }/edit/${numericalSeriesId}`,
    );

  /**
   * Handles edit action for new company bank account form submit.
   * @param values form data
   */
  const handleSubmit = async (values: Values) => {
    try {
      startLoading();
      const response = await http.apiPut({
        url: `${apiUrl.NUMERICAL_SERIES_SET_COUNTER}?id=${id}&number=${values.number}`,
        data: values,
      });
      if (response?.status === 204) {
        stopLoading();
        toast.success('Success!');
      }
    } catch (err) {
      stopLoading();
      handleApiErrors(err);
    }
  };

  return (
    <div className="w-1/4	space-y-8">
      <h1 className="text-3xl font-bold">{t('page.numerical-serie.headline-counter-edit')}</h1>
      <NumericalSeriesCounterForm
        onSubmit={handleSubmit}
        initialValues={{ id: id, number: counter } as Values}
        onBack={handleOnBack}
      />
    </div>
  );
};
